export default "assets/images/texture_papier-99577c9b.jpg";